export default "__VITE_ASSET__BX9E0oWr__"